import { render, staticRenderFns } from "./GuestProfileConsents.vue?vue&type=template&id=6c8571a7&"
import script from "./GuestProfileConsents.vue?vue&type=script&lang=js&"
export * from "./GuestProfileConsents.vue?vue&type=script&lang=js&"
import style0 from "./GuestProfileConsents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports